import { BRAND } from "constants/brand";
import "./addProduct.scss";
import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";

import { Ring } from "@uiball/loaders";
import useProduct from "hooks/useProducts";
import { useGetVendorsDropdown } from "hooks/useVendors";
import useCategories from "hooks/useCateogries";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import OptionGroup from "./OptionGroup/OptionGroup";
import { useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import useOptions from "hooks/useOptions";
import { useSelector } from "react-redux";
import Select from "components/Ui/SelectField/SelectField";
import { fieldOf } from "utils/formField";
import { readApiError } from "utils/apiError";

const AddProduct = (props) => {
    const [image, setImage] = useState(null);
    const adminInfo = useSelector((state) => state.auth.userData);
    const [vendor, setvendor] = useState(null);
    const [category, setCategory] = useState(null);
    const [OptionGroupsNumber, setOptionGroupsNumber] = useState(0);
    const [OptionGroups, setOptionGroups] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const { vendors } = useGetVendorsDropdown();
    const { categories } = useCategories();
    const form = useRef();
    const { loading, createProduct, error, createGroup } = useProduct();
    const navigate = useNavigate();
    const { options, fetchOptions } = useOptions();
    const getOptionData = (data) => {
        const options = productOptions.filter((option) => +option.id !== +data.id);
        options.push(data);
        setProductOptions(options);
    };

    useEffect(() => {
        fetchOptions({});
    }, []);

    useEffect(() => {
        const optionList = [];
        for (let i = 0; i < OptionGroupsNumber; i++) {
            optionList.push(<OptionGroup getOptionData={getOptionData} key={i} />);
        }
        setOptionGroups(optionList);
    }, [OptionGroupsNumber]);

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const compressedFile = await imageCompression(file, {
                    maxWidthOrHeight: 1024, // Resize to max 1024px width/height
                    maxSizeMB: 0.6, // Limit to 1MB
                });
                const compressedFileObj = new File([compressedFile], file.name, {
                    type: file.type,
                });

                setImage(compressedFileObj); // Set resized image preview
            } catch (error) {
                console.error("Error resizing image:", error);
            }
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        const productData = new FormData();

        if (fieldOf(form.current, "image").files[0]) {
            productData.append("image", image, fieldOf(form.current, "image").files[0].name);
        }
        productData.append("title", fieldOf(form.current, "title").value);
        if (adminInfo.role === "vendor") {
            productData.append("vendorId", adminInfo.id);
            productData.append("categoryId", category);
            productData.append("price", fieldOf(form.current, "price").value);
            productData.append("description", fieldOf(form.current, "description").value);
            productData.append("order", fieldOf(form.current, "order").value);
            productData.append("offerPrice", fieldOf(form.current, "offerPrice").value || 0);
            productData.append("isOffer", fieldOf(form.current, "isOffer").checked);
            productData.append("featured", fieldOf(form.current, "featured").checked);
            productData.append("available", fieldOf(form.current, "available").checked);
            productData.append("show_price", fieldOf(form.current, "show_price").checked);
            productData.append("isNewCart", fieldOf(form.current, "isNewCart").checked);
        } else {
            productData.append("vendorId", vendor);
            productData.append("categoryId", category);
            productData.append("price", fieldOf(form.current, "price").value);
            productData.append("description", fieldOf(form.current, "description").value);
            productData.append("order", fieldOf(form.current, "order").value);
            productData.append("offerPrice", fieldOf(form.current, "offerPrice").value || 0);
            productData.append("isOffer", fieldOf(form.current, "isOffer").checked);
            productData.append("featured", fieldOf(form.current, "featured").checked);
            productData.append("available", fieldOf(form.current, "available").checked);
            productData.append("show_price", fieldOf(form.current, "show_price").checked);
            productData.append("isNewCart", fieldOf(form.current, "isNewCart").checked);
        }

        try {
            const response = await createProduct(productData);
            const groupFormData = new FormData();
            groupFormData.append("products", JSON.stringify([response.product?.id]));
            groupFormData.append("groupsData", JSON.stringify(productOptions));

            productOptions.forEach((group, groupIndex) => {
                group.options.forEach((option, optionIndex) => {
                    // Example: if you have a File object for this option
                    const file = option.image; // 👈 must come from <input type="file" /> or similar

                    if (file) {
                        // The key includes indexes so the backend knows which option this image belongs to
                        groupFormData.append(
                            `groups[${groupIndex}][options][${optionIndex}][image]`,
                            file,
                        );
                    }
                });
            });
            const groupResponse = await createGroup(groupFormData);
            // The product exists now, and its groups do not: say so, and open
            // the product, so the admin repairs the groups and does not add it
            // a second time.
            const groupError = readApiError(groupResponse, "تعذر حفظ الخيارات");
            if (response.product && groupError) {
                props.showMessage("error", "تمت إضافة المنتج، ولم تُحفظ الخيارات", groupError);
                navigate(`/products/${response.product.id}`);
                return;
            }

            if (response.product) {
                props.showMessage("success", "تمت الاضافه", "تمت إضافه المنتج بنجاح");
                navigate("/products");
            } else {
                props.showMessage(
                    "error",
                    "هناك خطأ",
                    response?.response?.data?.message ||
                        response?.message ||
                        error ||
                        "حدث خطأ غير متوقع",
                );
            }
        } catch (err) {
            console.error("Error adding vendor:", err);
            props.showMessage("error", "هناك خطأ", error || "حدث خطأ غير متوقع");
        }
    };

    const vendorOptions = vendors?.map((v) => ({
        value: v.id,
        label: v.name,
    }));

    const categorieOptions = categories?.map((v) => ({
        value: v.id,
        label: v.name,
    }));

    return (
        <div className={`add-product`}>
            {loading ? (
                <div className="loading-spinner center">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : null}
            <h3 className="text-center" style={{ marginBottom: "20px" }}>
                إضافة منتج
            </h3>
            <form ref={form} className="row row-cols-1" onSubmit={submitHandler}>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="image">
                        <Form.Label>
                            صوره المنتج<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                            name="image"
                            onChange={handleImageChange}
                            type="file"
                            accept=".png,.jpg,.jpeg,.svg,.webp"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>
                            اسم المنتج<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control name="title" type="text" placeholder="اسم المنتج" required />
                    </Form.Group>
                </div>
                {adminInfo.role !== "vendor" && (
                    <div className="col-md-4 col-lg-4">
                        <Form.Group className="mb-3" controlId="vendor">
                            <Form.Label>
                                المطعم<span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Select
                                options={vendorOptions}
                                placeholder="اختر المطعم"
                                onChange={(selected) => {
                                    setvendor(selected.value);
                                }}
                                isSearchable
                            />
                        </Form.Group>
                    </div>
                )}

                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="category">
                        <Form.Label>
                            القسم<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Select
                            options={categorieOptions}
                            placeholder="اختر القسم"
                            onChange={(selected) => {
                                setCategory(selected.value);
                            }}
                            isSearchable
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="price">
                        <Form.Label>
                            السعر (₪)<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                            name="price"
                            type="number"
                            min={0}
                            placeholder="السعر"
                            required
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="desc">
                        <Form.Label>الوصف</Form.Label>
                        <Form.Control name="description" type="text" placeholder="الوصف" />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId=" offerPrice">
                        <Form.Label>ترتيب الظهور</Form.Label>
                        <Form.Control
                            name="order"
                            type="number"
                            defaultValue={1}
                            min={1}
                            placeholder=""
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId=" offerPrice">
                        <Form.Label>السعر بعد الخصم (₪)</Form.Label>
                        <Form.Control
                            name="offerPrice"
                            type="number"
                            min={0}
                            placeholder="السعر بعد الخصم"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="isOffer"
                                    defaultChecked={false}
                                    color="warning"
                                    onChange={(e) => {}}
                                />
                            }
                            label="تفعيل العرض"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="featured"
                                    defaultChecked={false}
                                    color="warning"
                                    onChange={(e) => {}}
                                />
                            }
                            label="هل هذا المنتج مميز"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="available"
                                    defaultChecked={false}
                                    color="warning"
                                    onChange={(e) => {}}
                                />
                            }
                            label="هل هذا المنتج متاح؟"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="show_price"
                                    defaultChecked={false}
                                    color="warning"
                                    onChange={(e) => {}}
                                />
                            }
                            label="هل يظهر سعر المنتج؟"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="isNewCart"
                                    defaultChecked={true}
                                    color="warning"
                                    onChange={(e) => {}}
                                />
                            }
                            label="هل يستخدم نظام السلة الجديد؟"
                        />
                    </FormGroup>
                </div>
                <div>
                    <button
                        style={{ margin: "40px 0 0 10px", minWidth: "fit-content" }}
                        className="button"
                        onClick={() => {
                            setOptionGroupsNumber((pre) => (pre += 1));
                        }}
                        type="button"
                    >
                        إضافه خيار
                    </button>
                    <button
                        style={{ marginTop: "40px", background: "red", color: "#fff" }}
                        disabled={OptionGroupsNumber === 0 ? true : false}
                        onClick={() => {
                            setOptionGroupsNumber((pre) => (pre -= 1));
                            setProductOptions((pre) => (pre = pre.slice(0, pre.length - 1)));
                        }}
                        type="button"
                    >
                        حذف خيار
                    </button>
                </div>
                {OptionGroups.map((item, index) => (
                    <OptionGroup
                        key={index}
                        index={index}
                        getOptionData={getOptionData}
                        options={options}
                    />
                ))}
                <div className="submit">
                    <button
                        style={{
                            marginTop: "20px",
                            width: "250px",
                            fontWeight: "bold",
                            float: "left",
                        }}
                        className="button"
                        type="submit"
                    >
                        إضافه المنتج
                    </button>
                </div>
            </form>
        </div>
    );
};
export default AddProduct;
